<template>
    <div>
        <b-row>
            <b-col sm="12" md="12" lg="12" xl="12" class="prestacao-component">
                <b-card no-body class="card-no-body">
                    <h1>Informações das Prestações de Contas</h1>
                    <b-card-body>
                            <template>
                                <div>
                                    <div class="accordion">

                                        <div v-for="prestacao in prestacoes" :key="prestacao.idPrestacaoContasMensal" class="menu">
                                            <button @click="toggleMenu(prestacao.idPrestacaoContasMensal)">
                                            Prestação de Contas -
                                            PC-{{
                                                prestacao.dtPrestacao
                                                    ? $moment(prestacao.dtPrestacao).format('YYYY')
                                                    : ''
                                            }}-{{ prestacao.idPrestacaoContasMensal }} |
                                            {{
                                                prestacao.dtPrestacao
                                                    ? $moment(prestacao.dtPrestacao).format('MMMM/YYYY').charAt(0).toUpperCase()
                                                    + $moment(prestacao.dtPrestacao).format('MMMM/YYYY').slice(1)
                                                    : ''
                                            }}
                                            </button>
                                            <div v-show="prestacao.open" class="content">
                                             <detalhes-prestacao-contas
                                                :prestacao="prestacao"
                                                :dtPrestacao="prestacao.dtPrestacao"
                                                :tempoParcialEncerramentoEmDias="prestacao.tempoParcialEncerramentoEmDias"
                                                ></detalhes-prestacao-contas>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                           </template>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    //import RelatorioServicos from './RelatoriosServicos'
    import DetalhesPrestacaoContas from './DetalhesPrestacaoContas'
    export default {

        components: {
            DetalhesPrestacaoContas,
        },

        props: {
            convenio: {
            type: Object,
            required: true
            },
            prestacoes: {
                type: Array,
                default: () => []
            },
        },

    methods: {

        toggleMenu(idPrestacaoContasMensal) {
        this.prestacoes = this.prestacoes.map(prestacao => {
        if (prestacao.idPrestacaoContasMensal === idPrestacaoContasMensal) {
            prestacao.open = !prestacao.open;
            prestacao.dtPrestacao = prestacao.dtPrestacao || null;
                }
                return prestacao;
            });
        }
        }

    }
</script>

<style scoped>
.prestacao-component {
  margin-top: 20px;
}

.card-no-body {
  margin: 0;
  padding: 0;
  border-radius: 10px;
  overflow: hidden;
}

.card-no-body h1 {
  background-color: #f9f9f9;
  padding: 15px;
  margin: 0;
  font-size: 1.5em;
  font-weight: bold;
  border-bottom: 1px solid #ddd;
  text-align: left;
  border-radius: 10px 10px 0 0;
}

.card-no-body b-card-body {
  padding: 20px;
  margin: 0;
  background-color: #ffffff;
  border: 1px solid #ddd;
  border-top: none;
  border-radius: 0 0 10px 10px;
}

.accordion .menu {
  margin: 10px 0;
  border: 1px solid #ddd;
  border-radius: 10px;
  overflow: hidden;
}

.accordion button {
  display: block;
  width: 100%;
  text-align: left;
  padding: 15px;
  background-color: #f9f9f9;
  border: none;
  border-bottom: 1px solid #ddd;
  cursor: pointer;
  font-weight: bold;
}

.accordion button:hover {
  background-color: #eaeaea;
}

.accordion .content {
  background-color: #ffffff;
  padding: 15px;
  border-top: 1px solid #ddd;
}

button:focus {
  outline: none;
  box-shadow: none;
}
</style>
